//---------------------------------
// load race characteristic values
//---------------------------------
export default function loadRaceCharacteristicValues(objects) {
  console.log('-----------------------------------')
  console.log('IN loadRaceCharacteristicValues...')
  //-------------------
  // loop thru objects
  //-------------------
  for (let i = 0; i < objects.length; i++) {
    //-----------
    // get chars
    //-----------
    let chars = objects[i].characteristics
    // console.log("chars len = " + chars.length);
    if (chars.length > 0) {
      // -------------------------------------------------
      // load existing char values where exist (catchall)
      // -------------------------------------------------
      chars.forEach((c) => {
        switch (c.name) {
          //
          case 'str':
            objects[i].str = c.value
            objects[i].str_dice_roll = c.dice_roll ?? 0
            // console.log("STR = " + c.value);
            break
          //
          case 'con':
            objects[i].con = c.value
            objects[i].con_dice_roll = c.dice_roll ?? 0
            break
          //
          case 'dex':
            objects[i].dex = c.value
            objects[i].dex_dice_roll = c.dice_roll ?? 0
            break
          //
          case 'siz':
            objects[i].siz = c.value
            objects[i].siz_dice_roll = c.dice_roll ?? 0
            break
          //
          case 'int':
            objects[i].int = c.value
            objects[i].int_dice_roll = c.dice_roll ?? 0
            break
          //
          case 'pow':
            objects[i].pow = c.value
            objects[i].pow_dice_roll = c.dice_roll ?? 0
            break
          //
          case 'cha':
            objects[i].cha = c.value
            objects[i].cha_dice_roll = c.dice_roll ?? 0
            break
          //
          default:
        }
      })
    }
  }
  return objects
}
